import clientFetcher from '@finance/clientFetcher';
import { Temporal } from '@js-temporal/polyfill';
import { Document } from 'fluent-graphql';
import type { AccountTransfer, Errors, TypedObject } from '../types';

export interface UpdateAccountTransferReturn {
  updateAccountTransfer: AccountTransfer | { reference: string } & TypedObject | Errors;
}

interface UpdateAccountTransferVars {
  organizationId: string;
  accountTransferId: string;
  input: unknown;
}

export default Document
  .mutation<UpdateAccountTransferReturn, UpdateAccountTransferVars>('UpdateAccountTransfer')
    .variableDefinitions({ organizationId: 'ID!', accountTransferId: 'ID!', input: 'UpdateAccountTransferInput!' })
    .union('updateAccountTransfer')
      .useVariables({ organizationId: 'organizationId',  accountTransferId: 'accountTransferId', input: 'input' })
      .onEntity('AccountTransfer')
        .scalar('organizationId')
        .scalar('date', Temporal.PlainDate.from)
        .reference('sourceCurrencyId', 'Currency')
        .reference('targetCurrencyId', 'Currency')
        .reference('sourceAccountId', 'Account')
        .reference('targetAccountId', 'Account')
        .scalar('sourceAmount')
        .scalar('targetAmount')._
      .onTypedObject('NegativeAccountBalance')
        .scalar('name')
        .scalar('currencyName')
        .scalar('balanceAmount')._
      .onTypedObject('InputErrors')
        .scalar('errors')._._._
  .makeExecutable(clientFetcher)
  .afterExecution(({ updateAccountTransfer: data }) => {
    if (data.__typename === 'AccountTransfer') {
      Document.clearQueries([
        'AccountTransfers',
        'AccountTransactions',
        'Accounts'
      ]);
    }
  });
